import differenceWith from 'lodash.differencewith';
import isEqual from 'lodash.isequal';

export default function getRelationshipRecords<T, N>(
  existing: T[],
  incoming: T[],
  cb: (item: T) => N,
  id?: string,
) {
  const iteratorFn = (item: any, other: any) => {
    const checkedItem = id ? item[id] : item;
    const checkedOther = id ? other[id] : other;
    return isEqual(checkedItem, checkedOther);
  };

  return {
    added: differenceWith(incoming, existing, iteratorFn).map((item) =>
      cb(item),
    ),
    removed: differenceWith(existing, incoming, iteratorFn),
  };
}
